import React from 'react';
import Form from 'react-bootstrap/Form';
import RichText from '../controls/RichText';
import NeutralToggle from '../controls/NeutralToggle';
import { useForceUpdate, getRawText } from '../util';
import { deepMap, hydrate, Content } from '../DataStructures';
import { TabContextReporter } from '../TabContext';
import { Range } from 'slate';
import { FormValidityProvider, FormValidityReporter } from '../FormValidity';
import TaskSelect from './TaskSelect';
const DEBUG = false;
export default function TaskDropdownMulti(props) {
  const [collapsed, setCollapsed] = React.useState(true);
  const editorRef = /*#__PURE__*/React.createRef();
  const customEditorRef = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement(FormValidityProvider, {
    onChange: props.onValidityChange
  }, /*#__PURE__*/React.createElement(TabContextReporter, {
    index: "0",
    title: "Initial Information"
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, null, /*#__PURE__*/React.createElement("b", null, "TaskSelect:"), " ", /*#__PURE__*/React.createElement("i", null, "Press the Task Select button to insert a Task Select Component into this text field")), /*#__PURE__*/React.createElement(RichText, {
    onClickNonEditable: () => {
      DEBUG && console.log("InteractiveEditor onClickNonEditable");
    },
    value: props.data.children,
    onChange: v => {
      props.data.children = v;
      //forceUpdate()
      props.onChanged();
    },
    toolbar: [{
      type: 'Component',
      tagName: "TaskSelect",
      title: 'Task Select',
      icon: 'plus-square',
      variant: 'primary',
      onSelect: console.log,
      props: {
        srOnly: true,
        options: [new Content(""), new Content("")],
        feedback: [new Content(""), new Content("")],
        //buttonWidth: "100px",
        //matchWidth: "button",
        correct: 1,
        inline: true,
        label: new Content("Help text for this dropdown")
      }
    }],
    editorRef: editorRef,
    customEditorRef: customEditorRef,
    onSelect: e => {
      let editor = editorRef.current;
      let CustomEditor = customEditorRef.current;
      let c = Range.isCollapsed(editor.selection);
      if (c !== collapsed) {
        setCollapsed(c);
      }
      const result = CustomEditor.getActiveTag(editor, "TaskSelect");
      if (!!result) {
        const [node, path] = result;
      }
    }
  })))));
}
TaskDropdownMulti.getHierarchyPaths = root => {
  return root.children.map((v, i) => {
    return ["Content", ["children", i]];
  });
};